import { Component, Input } from '@angular/core';
import { ReportService } from '../report-service/report.service';
import { ToasterService } from '@purespectrum1/ui/toaster-service';

@Component({
  selector: 'ps-report-sort-table',
  templateUrl: './report-sort-table.component.html',
  styleUrls: ['./report-sort-table.component.css'],
})
export class SortTableComponent {
  reportStatus = ['Pending', 'Ready', 'Error', 'Deleted'];

  constructor(
    private _reportService: ReportService,
    private _toaster: ToasterService
  ) {}
  @Input()
  public dataList: any[] = [];

  downloadFile(filename: any) {
    console.log(` Old download file method is called for file ${filename}`);
  }

  downloadReport(filename: string) {
    if (!filename) {
      return;
    }

    this._reportService.getReportDownloadUrl(filename).subscribe({
      next: (response) => {
        window.open(response.url, '_blank');
      },
      error: (err: { error: { msg: string } }) => {
        const errorMessage =
          err.error?.msg || 'Error fetching secure download link';
        this._toaster.error(errorMessage);
      },
    });
  }
}
